module.exports = __webpack_public_path__ + "static/media/sdl.ec74f6de.png";